import React from 'react';

type TableCellProps = {
    children: React.ReactNode;
    rowIndex: number;
    onClick?: () => void;
    id: string;
    sticky?: boolean;
    style?: React.CSSProperties;
    className?: string;
    title?: string;
}

const TableCell = ({ children, rowIndex, onClick, id, sticky, style, className, title }: TableCellProps) => {
    return (
        <td data-testid="components-tablecell-td-1"
            id={`${id}`}
            className={`table-item-style tw-align-top tw-truncate ${onClick ? 'tw-text-accent tw-cursor-pointer' : ''} ${sticky ? 'tw-sticky tw-left-0' : ''} ${rowIndex % 2 === 0 ? 'tw-bg-surface-sunken' : 'tw-bg-surface'} ${className || ''}`}
            onClick={onClick}
            style={style}
            title={title}
        >
            {children}
        </td>
    );
};

export default TableCell;